import { FormProvider as Form } from 'react-hook-form';
import type { FormProviderProps } from './types';

export default function FormProvider({ children, formKey, onSubmit, methods }: FormProviderProps) {
    return (
        <Form {...methods}>
            <form key={formKey} onSubmit={onSubmit}>
                {children}
            </form>
        </Form>
    );
}
